'use strict';

const isMobileDevice = require('./isMobileDevice');
const isTabletDevice = require('./isTabletDevice');

const isTouchDevice = () => {
    return isMobileDevice() || isTabletDevice();
};

module.exports = isTouchDevice;
